import pMemoize from "@-/com.npmjs.p-memoize";
import type { ComponentProps, ComponentType } from "react";
import { useAsyncComponent } from "@-/dev.improve.haniverse.lib.use-async-component";

type PieChartComponent = typeof import("react-native-gifted-charts/dist/PieChart").PieChart;
type PieChartProps = ComponentProps<PieChartComponent>;

const loadPieChart = pMemoize(async (): Promise<PieChartComponent> => {
  const { PieChart } = await import("react-native-gifted-charts/dist/PieChart");
  return PieChart;
});

function LoadedPieChart({
  Component,
  ...props
}: PieChartProps & { Component: ComponentType<PieChartProps> }) {
  return <Component {...props} />;
}

export function PieChart(props: PieChartProps) {
  const Component = useAsyncComponent(loadPieChart);
  return Component === null ? null : <LoadedPieChart Component={Component} {...props} />;
}
